import { ArrowRight, ArrowUpRight } from "lucide-react";
import { cx } from "../../lib/cx";
import { localHref } from "../../lib/links";
import ExternalLink from "./ExternalLink";

/** Bold arrow link. `external` opens in a new tab with a ↗ arrow. */
export default function TextLink({
  href,
  external = false,
  className,
  children,
}) {
  const classes = cx(
    "inline-flex items-center gap-2 font-bold transition-colors",
    className ?? "text-blue hover:text-blue-deep",
  );
  if (external)
    return (
      <ExternalLink className={classes} href={href}>
        {children}
        <ArrowUpRight size={17} />
      </ExternalLink>
    );
  return (
    <a className={classes} href={localHref(href)}>
      {children}
      <ArrowRight size={17} />
    </a>
  );
}
